import React, { useState } from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faMobileScreen } from '@fortawesome/pro-regular-svg-icons';
import styles from './EmailPreview.module.scss';

type Device = 'desktop' | 'mobile';

interface EmailPreviewProps {
    html: string;
    subject?: string;
    fromName?: string;
    previewText?: string;
    toolbar?: React.ReactNode;
    className?: string;
}

// Inbox-style preview: subject/from header + sandboxed iframe with a desktop/mobile toggle.
export const EmailPreview: React.FC<EmailPreviewProps> = ({
    html,
    subject,
    fromName,
    previewText,
    toolbar,
    className
}) => {
    const [device, setDevice] = useState<Device>('desktop');

    return (
        <div className={clsx(styles.root, className)}>
            <div className={styles.toolbar}>
                <div className={styles.devices}>
                    <button
                        type="button"
                        aria-label="Desktop preview"
                        className={clsx({ [styles.deviceOn]: device === 'desktop' })}
                        onClick={() => setDevice('desktop')}
                    >
                        <FontAwesomeIcon icon={faDesktop} />
                    </button>
                    <button
                        type="button"
                        aria-label="Mobile preview"
                        className={clsx({ [styles.deviceOn]: device === 'mobile' })}
                        onClick={() => setDevice('mobile')}
                    >
                        <FontAwesomeIcon icon={faMobileScreen} />
                    </button>
                </div>
                {toolbar}
            </div>

            <div className={styles.stage}>
                <div className={clsx(styles.frame, styles[device])}>
                    {(subject || fromName) && (
                        <div className={styles.inbox}>
                            <span className={styles.avatar}>{(fromName ?? 'C').charAt(0)}</span>
                            <div className={styles.inboxText}>
                                <span className={styles.from}>{fromName}</span>
                                <span className={styles.subject}>{subject || 'Subject line'}</span>
                                {previewText && <span className={styles.previewText}>{previewText}</span>}
                            </div>
                        </div>
                    )}
                    <iframe
                        title="Email preview"
                        sandbox=""
                        srcDoc={html}
                        className={styles.iframe}
                    />
                </div>
            </div>
        </div>
    );
};

export default EmailPreview;
